(ns ui.view.esign.signatory-table
  (:require
   [common.util :as cu]
   [oops.core :as oops]
   [reagent.core :as r]
   [ui.state.session.sub :as session-sub]
   [ui.components.button.view :as button]
   [ui.components.grid.view :refer [ag-grid-enterprise theme-quartz]]
   [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]
   [common.localization :as loc]
   [common.schema.entities.signatory :as signatory]
   [re-frame.core :as rf]
   [ui.util :as uu]))

(defn column-defs
  [{:keys [tenant send-reminder-to-signatory]}]
  [{:field      "signatory/name"
    :headerName "Name"}
   {:field      "signatory/email"
    :headerName "Email"
    :flex       1
    :minWidth   200}
   {:field      "signatory/last-reminded-on"
    :headerName "Last reminder sent on"
    :valueFormatter (fn [params]
                      (let [value (oops/oget params "value")]
                        (when-not (cu/blank-value? value)
                          (uu/display-datetime-timestamp tenant value))))}
   {:field      "signatory/sign-status"
    :headerName "Sign status"
    :valueFormatter (fn [params]
                      (let [value (oops/oget params "value")]
                        (if-not (cu/blank-value? value)
                          (let [value-kw (keyword "signatory.sign-status" value)
                                label (signatory/get-sign-status-label value-kw)]
                            label)
                          "")))}
   {:field        "actions"
    :headerName   ""
    :resizable    false
    :sortable     false
    :width        60
    :cellRenderer (fn [params]
                    (let [data (-> params
                                   (oops/oget "data")
                                   (js->clj :keywordize-keys true))
                          signatory-id (:db/id data)
                          signatory-email (:signatory/email data)
                          undecided-sign-status? (-> data
                                                     :signatory/sign-status
                                                     (= "undecided"))
                          items (vec
                                 (concat
                                  (when undecided-sign-status?
                                    [{:label      (loc/tr :send-reminder)
                                      :icon-class "fal fa-bell"
                                      :on-click #(send-reminder-to-signatory
                                                  {:signatory-id signatory-id
                                                   :signatory-email signatory-email})}])))]
                      (r/as-element
                       [:div
                        (when (seq items)
                          [dropdown-menu/view
                           {:props {:align :start
                                    :side  :left}
                            :trigger-as-child
                            [:span
                             [button/square-secondary-hollow
                              {}
                              [:i {:class "fal fa-ellipsis-h"}]]]

                            :items items}])])))}])

(defn signatories->row-data
  [signatories]
  (->> signatories
       (mapv (fn [signatory]
               (->> signatory
                    (mapv (fn [[field value]]
                            [(cu/kw->str field) value]))
                    (into {}))))))

(defn view
  [{:keys [signatories] :as args}]
  (let [tenant @(rf/subscribe [::session-sub/tenant])]
    [:div
     {:style {:height "auto"}}
     [:div
      {:class "h-full w-full"}
      [ag-grid-enterprise
       {:theme theme-quartz
        :domLayout   :autoHeight
        :columnDefs  (column-defs (assoc args :tenant tenant))
        :rowData     (signatories->row-data signatories)
        :popupParent (oops/ocall js/document "querySelector" "body")
        :defaultColDef {:sortable true
                        :suppressHeaderMenuButton true
                        :suppressColumnsToolPanel true
                        :suppressFiltersToolPanel true
                        :autoSize true
                        :resizable true
                        :suppressMovable true
                        :menuTabs []}}]]]))
